module.exports = __webpack_public_path__ + "img/easel-fill.083b3d98.svg";